<template>
  <div class="news">
    <!--顶部轮播 -->
    <div class="swpier">
      <img :src="swiperImage" alt="">
    </div>
    <div class="product">
      <div class="product-cont">
        <div class="product-box">
          <div class="news-box">
            <div class="news-title">
              {{ info.title }}
            </div>
            <!-- <div class="news-js">
              <div class="release-time">日期: {{ info.createtime || '' }}</div>
              <div class="author">来源: {{ info.author || '' }}</div>
            </div> -->
            <div class="news-content">
              <div v-html="info.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script >
import { solutionInfo, nav } from '@/request/api';
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      info: {},
      list: [],
      swiperImage: "",
      id: ""
    }
  },
  created() {
    this.id = this.$route.query.productId
  },
  mounted() {
    this.getNav()
    this.getDetails()
    this.getList()
  },
  methods: {
    getNav() {
      nav({}).then(res => {
        this.swiperImage = res.data[1].image
      })
    },
    getDetails() {
      solutionInfo({ id: this.id }).then(res => {
        if (res.code == 1) {
          this.info = res.data
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.swpier {
  margin-top: 90px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

.news-box {
  .news-title {
    margin-top: 30px;
    text-align: center;
    font-size: 30px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #333333;

  }

  .news-js {
    margin-top: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    color: #999999;

    .author {
      margin-left: 72px;
    }
  }

  .news-content {
    margin: 30px 0;
    border-top: 1px solid #C5C5C5;
    padding: 60px 0;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    color: #666666;
    line-height: 26px;
  }

  .news-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    color: #333333;

    p {
      cursor: pointer;
    }
  }

  .related-recommendations {
    margin-top: 83px;

    .related-recommendations-title {
      font-size: 20px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    .related-recommendations-list {
      margin-top: 29px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .related-recommendations-list-item {
        margin-right: 39px;
        margin-bottom: 30px;
        width: calc(100% / 4 - 39px);
        position: relative;
        background: #F6F6F6;

        .related-recommendations-list-item-box {
          padding: 35px 22px;
        }

        .item-line {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          height: 10px;
          background: #DB2733;
        }

        .item-time {
          font-size: 14px;

          color: #999999;
        }

        .item-title {
          margin-top: 14px;
          font-size: 20px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          line-height: 30px;
        }

        .item-content {
          margin-top: 22px;
          font-size: 16px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          overflow: hidden;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /*! autoprefixer: on */
          word-break: break-all;
          color: #666666;
          line-height: 32px;
        }

        .item-footer {
          display: flex;
          flex-direction: row-reverse;
        }

        .item-button {
          cursor: pointer;
          margin-top: 30px;
          font-size: 14px;

          color: #999999;
          height: 16px;

        }
      }

      .related-recommendations-list-item:last-child {
        margin-right: 0;
      }
    }
  }
}

@media screen and (max-width:767px) {
  .related-recommendations-list {
    display: block !important;

    .related-recommendations-list-item {
      margin-right: 0 !important;
      width: 100% !important;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/view/solution/SolutionDetails.vue